import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-pack-search',
  templateUrl: './pack-primary-accordian.component.html',
  styleUrls: ['./pack-primary-accordian.component.css']
})
export class  PackPrimaryAccordianComponent extends AbstractFormWidgetComponent {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/pack/pack-primary-accordian/pack-primary-accordian.component.ts